import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleServiceClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    navigate('/services');
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <footer className="text-white rounded-t-3xl mx-2 mt-24" style={{ background: 'linear-gradient(135deg, #0a3d18 0%, #0F5E26 50%, #5a3460 100%)' }}>
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Agency Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Alta Care Home Health, Inc.</h3>
            <p className="text-green-100 leading-relaxed mb-4">
              Providing compassionate, professional home health care services in Las Vegas since 2014.
              Your health and well-being are our top priorities.
            </p>
            <div className="flex items-center gap-2 text-sm" style={{ color: '#c9a8c8' }}>
              <i className="ri-shield-check-line"></i>
              <span>Licensed &amp; Insured</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer">Home</Link></li>
              <li><Link to="/about" className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer">About Us</Link></li>
              <li><Link to="/services" className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer">Services</Link></li>
              <li><Link to="/contact" className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#skilled-nursing" 
                  onClick={(e) => handleServiceClick(e, '#skilled-nursing')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Skilled Nursing
                </a>
              </li>
              <li>
                <a 
                  href="#physical-therapy" 
                  onClick={(e) => handleServiceClick(e, '#physical-therapy')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Physical Therapy
                </a>
              </li>
              <li>
                <a 
                  href="#occupational-therapy" 
                  onClick={(e) => handleServiceClick(e, '#occupational-therapy')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Occupational Therapy
                </a>
              </li>
              <li>
                <a 
                  href="#speech-therapy" 
                  onClick={(e) => handleServiceClick(e, '#speech-therapy')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Speech Therapy
                </a>
              </li>
              <li>
                <a 
                  href="#home-health-aide" 
                  onClick={(e) => handleServiceClick(e, '#home-health-aide')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Home Health Aide
                </a>
              </li>
              <li>
                <a 
                  href="#medical-social-worker" 
                  onClick={(e) => handleServiceClick(e, '#medical-social-worker')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Medical Social Worker
                </a>
              </li>
              <li>
                <a 
                  href="#nutritional-guidance" 
                  onClick={(e) => handleServiceClick(e, '#nutritional-guidance')}
                  className="text-green-100 transition-colors hover:text-[#c9a8c8] cursor-pointer"
                >
                  Nutritional Guidance
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line mt-1" style={{ color: '#c9a8c8' }}></i>
                <div>
                  <a href="tel:7024789934" className="text-green-100 hover:text-white transition-colors">702-478-9934</a>
                  <p className="text-sm text-green-200">Mon-Fri: 9:00 AM - 5:30 PM</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line mt-1" style={{ color: '#c9a8c8' }}></i>
                <a href="mailto:info@altacarehomehealth.com" className="text-green-100 hover:text-white transition-colors">info@altacarehomehealth.com</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-global-line mt-1" style={{ color: '#c9a8c8' }}></i>
                <a href="https://www.altacarehomehealth.com/" target="_blank" rel="noopener noreferrer" className="text-green-100 hover:text-white transition-colors">www.altacarehomehealth.com</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line mt-1" style={{ color: '#c9a8c8' }}></i>
                <p className="text-green-100">2675 South Jones Blvd., Suite 112<br />Las Vegas, Nevada 89146</p>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a 
                href="https://www.facebook.com/altacarehealth" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#844C83')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')}
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="https://www.instagram.com/altacare_homehealth" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#844C83')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')}
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="https://www.youtube.com/channel/UC85DcupmWy30mmq1iDXQ49w" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#844C83')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)')}
              >
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-green-200 text-sm">
            © 2026 Alta Care Home Health, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
